import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";


import Home from "./pages/Home";
import AboutCEO from "./pages/AboutCEO";
import Career from "./pages/Career";
import Apply from "./pages/Apply";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Contact from "./pages/Contact";
import Messages from "./admin/Messages";
 import AdminApplicants from "./pages/AdminApplicants";

// 🔥 Navbar hide on Admin pages
function Layout() {
  const location = useLocation();
  const hideNavbar = location.pathname.startsWith("/dashboard");

  return (
    <>
      {!hideNavbar && <Navbar />}

      <Routes>
        {/* 🌍 Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutCEO />} />
        <Route path="/career" element={<Career />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/apply/:id" element={<Apply />} />
       <Route path="/admin/applicants" element={<AdminApplicants />} />

        {/* 🔐 Protected Route */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
  path="/admin/messages"
  element={
    <ProtectedRoute>
      <Messages />
    </ProtectedRoute>
  }
/>
      </Routes>
    </>
    
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;